import { Mic, Theater, Music, Sparkles, Palette, PartyPopper, Baby, Cpu, Lightbulb } from "lucide-react";

const performanceForms = [
  { icon: Mic, title: "Stand-up i kabaret", description: "Klasyczna komedia sceniczna - od stand-upu po skecze kabaretowe." },
  { icon: Music, title: "Muzyka na żywo", description: "Koncerty, DJ-e, zespoły coverowe i oprawa muzyczna wydarzeń." },
  { icon: Theater, title: "Taniec i ruch", description: "Pokazy taneczne, akrobatyka i dynamiczne choreografie." },
  { icon: Sparkles, title: "Widowiska i efekty", description: "Pokazy ognia, lasery, iluzja i efekty specjalne." },
  { icon: Palette, title: "Sztuka i warsztaty", description: "Interaktywne warsztaty kreatywne i pokazy artystyczne." },
  { icon: PartyPopper, title: "Eventy i rozrywka", description: "Prowadzenie imprez, quizy, gry i atrakcje eventowe." },
  { icon: Baby, title: "Dla dzieci", description: "Animacje, klauni, bańki mydlane i zabawy dla najmłodszych." },
  { icon: Cpu, title: "Technologia i AI", description: "Nowoczesne atrakcje z wykorzystaniem sztucznej inteligencji." },
  { icon: Lightbulb, title: "Improwizacja", description: "Spontaniczne tworzenie scenek na podstawie sugestii publiczności." },
];

export const FormsOfComedy = () => {
  return (
    <section className="py-24 section-dark relative overflow-hidden">
      <div className="absolute inset-0 mesh-gradient opacity-40" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-space-grotesk font-bold text-center mb-4 text-foreground">
          Formy <span className="text-gradient">występów</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Różnorodne formaty rozrywki na każdą okazję
        </p>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          {performanceForms.map((form) => {
            const Icon = form.icon;
            return (
              <div key={form.title} className="glass rounded-2xl p-6 hover:bg-white/[0.08] hover:border-primary/20 transition-all duration-300 hover:-translate-y-1 group">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-lg font-space-grotesk font-bold mb-2 text-foreground">{form.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{form.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
